import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import {
  useAlloyFeatureFlag,
  useCurrentProject,
  useCurrentProjectIsTemplate,
  useCurrentProductId,
  TOOL_IDS,
} from '@adsk/alloy-provider';
import SideNavigation, {
  SideNavigationItem,
} from '@adsk/alloy-side-navigation';

import ProjectTemplateSettingsSideNavigationItem from './ProjectTemplateSettingsSideNavigationItem';

const useNavigationItems = () => {
  const currentProject = useCurrentProject();
  const currentProductId = useCurrentProductId();

  const { value: showProgressTrackingService } = useAlloyFeatureFlag(
    'show-progress-tracking-service'
  );

  return useMemo(
    () =>
      currentProject?.products
        ?.find((p) => p.key === currentProductId)
        ?.tools?.filter(
          (tool) =>
            !(
              !showProgressTrackingService &&
              tool.key === TOOL_IDS.PROGRESS_TRACKING
            )
        ) || [],
    [currentProject, currentProductId, showProgressTrackingService]
  );
};

const ProjectTemplateSideNavigationItem = ({
  showTemplatesDivider,
  ...props
}) => {
  if (props.item.key === TOOL_IDS.CONFIGURATION) {
    return (
      <ProjectTemplateSettingsSideNavigationItem
        showTemplatesDivider={showTemplatesDivider}
        {...props}
      />
    );
  }
  return <SideNavigationItem {...props} />;
};

ProjectTemplateSideNavigationItem.propTypes = SideNavigationItem.propTypes;

const ConnectedSideNavigation = ({ selectedId, route }) => {
  const currentProjectIsTemplate = useCurrentProjectIsTemplate();
  const navigationItems = useNavigationItems();
  const showTemplatesDivider =
    currentProjectIsTemplate &&
    navigationItems.filter((item) => item.key !== TOOL_IDS.CONFIGURATION)
      .length > 0;
  return (
    <SideNavigation
      selectedId={selectedId}
      route={route}
      topItems={navigationItems}
      renderItem={
        currentProjectIsTemplate
          ? (props) => (
              <ProjectTemplateSideNavigationItem
                showTemplatesDivider={showTemplatesDivider}
                {...props}
              />
            )
          : /* use default prop value */ undefined
      }
    />
  );
};

ConnectedSideNavigation.propTypes = {
  /** Location path of current view */
  route: PropTypes.string,
  /** The current selected service ID */
  selectedId: PropTypes.string,
};

export { ConnectedSideNavigation };
